import React from 'react'

import {
  FormControlLabel,
  FormControlLabelProps,
  Switch as MuiSwitch,
  SwitchProps as MuiSwitchProps
} from '@mui/material'

export type SwitchProps = Omit<MuiSwitchProps, 'size'> & {
  label?: string
  labelPlacement?: FormControlLabelProps['labelPlacement']
  labelProps?: FormControlLabelProps['sx']
}

const Switch = ({
  label,
  labelPlacement,
  labelProps,
  color = 'secondary',
  value,
  ...props
}: SwitchProps) => {
  if (label) {
    return (
      <FormControlLabel
        label={label}
        labelPlacement={labelPlacement}
        control={<MuiSwitch color={color} {...props} />}
        sx={labelProps}
      />
    )
  }

  return <MuiSwitch color={color} {...props} />
}

export default Switch
